<script>
import { MessageType } from './constants';
import { Duration } from 'luxon';
import { ActionCableService } from './services';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    data(){
        return {
            clockRunning: false,
            currentClockTime: 0,
            showTopicInformation: 0,
            topic_interval: null,
            files: [],
            newComment: null
        }
    },
    computed:{
        actionHanlderDecider(message){
            return {
                [MessageType.SUBSCRIBED]: this.onSubscribe,
                [MessageType.CHOOSE_TOPIC]: this.onChooseTopic,
                [MessageType.START_TOPIC]: this.onStartTopic,
                [MessageType.FINISH_TOPIC]: this.onFinishTopic,
                [MessageType.PAUSE_TOPIC]: this.onPauseTopic,
                [MessageType.CHANGE_TOPIC_DURATION]: this.onChangeTopicDuration,
                [MessageType.CHANGE_TOPIC_POSITION]: this.onChangeTopicPosition,
                [MessageType.FINISH_MEET]: this.onFinishMeet,
                [MessageType.CREATE_COMMENT]: ()=>{},
                [MessageType.USER_ENTER]: ()=>{},
                [MessageType.USER_LEFT]: ()=>{}
            };
        },
        clockTimeDisplay(){
            if(this.currentClockTime < 0){
                return Duration.fromObject({ seconds: -this.currentClockTime }).toFormat('-hh:mm:ss');
            }
            return Duration.fromObject({ seconds: this.currentClockTime }).toFormat('hh:mm:ss');
        },
        displayTopicDuration(){
            return Duration.fromObject({ minutes: this.currentTopic.duration }).toFormat('mm:ss');
        },
        currentTopicClass(){
            return {
                'current-topic': true,
                'negative-time': this.currentClockTime < 0,
                'no-topic': !this.currentTopicSelected
            }
        },
        currentTopicSelected(){
            return this.currentTopic != null
        },
        topic(){
            return this.currentTopic;
        },
        user(){
            return this.findUser(this.topic.responsible_id);
        },
        users(){
            return this.users;
        },
        ...mapState('operationModule', ['users']),
        ...mapGetters('operationModule', ['currentTopic', 'actionData', 'actionType', 'findUser'])
    },
    methods:{
        onSubscribe(args={}){
            this.clockRunning = this.actionData.clock_running;
            this.currentClockTime = this.actionData.current_clock_time;
            if(this.clockRunning){
                if(this.topic_interval){
                    clearInterval(this.topic_interval);
                }
                this.topic_interval = setInterval(() => {this.currentClockTime -= 1;}, 1000);
            }
            if(this.currentTopic){
                this.files = [this.currentTopic.file_paths, this.currentTopic.file_names]
            }
        },
        onChooseTopic(args={}){
            this.currentClockTime =  this.currentTopic.duration * 60;
            this.clockRunning = false;
            if(this.topic_interval){
                clearInterval(this.topic_interval);
            }
            this.files = [this.currentTopic.file_paths, this.currentTopic.file_names]
            this.sendStartTopic()
        },
        onChangeTopicPosition(args={}){

        },
        onStartTopic(args={}){
            if (!this.clockRunning) {
                if(this.topic_interval){
                    clearInterval(this.topic_interval);
                }
                this.topic_interval = setInterval(() => {this.currentClockTime -= 1;}, 1000);
                this.clockRunning = true;
            }
        },
        onFinishTopic(args={}){
            clearInterval(this.topic_interval);
            this.currentClockTime = 0
        },
        onPauseTopic(args={}){
            clearInterval(this.topic_interval);
            this.clockRunning = false;
            this.pauseTimer();
        },
        onChangeTopicDuration(args={}){
            var duration_change = this.actionData.new_duration - this.currentTopic.duration;
            this.changeTopicDuration({topicId: this.currentTopic.id, newDuration: this.actionData.new_duration});
            this.currentClockTime += duration_change*60
        },
        onFinishMeet(){
            this.endTopic();
        },
        updateData(key, value){
            this.data = {...this.data, [key]: value};
        },
        sendStartTopic(){
            ActionCableService.startTopic();
        },
        sendPauseTopic(){
            ActionCableService.pauseTopic();
        },
        addTime(time){
            ActionCableService.changeTopicDuration({duration: this.currentTopic.duration + time});
        },
        viewDescription(){
            this.showTopicInformation = 0;
        },
        viewComments(){
            this.showTopicInformation = 1;
        },
        viewFiles(){
            this.showTopicInformation = 2;
        },
        endTopic(){
            ActionCableService.finishTopic();
        },
        sendCreateComment(){
            ActionCableService.createComment({comment: this.newComment, topicId: this.currentTopic.id});
            this.newComment = '';
        },
        ...mapActions('operationModule', ['pauseTimer', 'changeTopicDuration'])
    },
    watch: {
        'actionType':{
            deep: true,
            handler(newVal, oldVal){
                var actionHandler = this.actionHanlderDecider[newVal];
                actionHandler();
            }
        }
    }

}
</script>